import { Route, Routes } from 'react-router-dom'

import Details from './screens/Details'
import Relations from './screens/Relations'
import SalesforceDetails from './screens/SalesforceDetails'

const ProviderEditRoutes = () => (
  <Routes>
    <Route index element={<Details />} />
    <Route path="/relations" element={<Relations />} />
    <Route path="/salesforceDetails" element={<SalesforceDetails />} />
  </Routes>
)

export default ProviderEditRoutes
